import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

/**
 * Export tabular data to Excel (.xlsx).
 * @param {Array<Object>} rows - Array of flat objects.
 * @param {string} filename - Target filename (without extension).
 * @param {string} [sheetName] - Worksheet name.
 */
export function exportToExcel(rows, filename = 'export', sheetName = 'Sheet1') {
  if (!rows.length) return;
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([buf], { type: 'application/octet-stream' }), `${filename}.xlsx`);
}

/**
 * Export tabular data to CSV.
 * @param {Array<Object>} rows
 * @param {string} filename
 */
export function exportToCSV(rows, filename = 'export') {
  if (!rows.length) return;
  const ws = XLSX.utils.json_to_sheet(rows);
  const csv = XLSX.utils.sheet_to_csv(ws);
  saveAs(new Blob([csv], { type: 'text/csv;charset=utf-8' }), `${filename}.csv`);
}
